import React, {useEffect, useState} from "react";
import { Box, Typography, Grid } from "@mui/material";
import { currencyList } from "../../../constants/helpers";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import { renderIcon } from "../../../constants/icons/CurrencySymbol";
import { getSalaryWitComma } from "../../../utils/helpers";

const Highlight = () => {
    const jobLocation = useSelector((state: RootState) => state.campaign.jobLocation);
    const minExperience = useSelector((state: RootState) => state.campaign.minExperience);
    const maxExperience = useSelector((state: RootState) => state.campaign.maxExperience);
    const minSalary = useSelector((state: RootState) => state.campaign.minSalary);
    const maxSalary = useSelector((state: RootState) => state.campaign.maxSalary);
    const currency = useSelector((state: RootState) => state.campaign.currency);
    const [currencyType,setCurrencyType] = useState<any>('')

    const renderCurrencyContent = () => {
      if (currency === 'MYR' || currency === 'PHP') {
        const icon = renderIcon(currencyType);
        
        if (icon) {
          return icon;
        } else {
          return (
            <span 
              style={{
                fontSize: '11px',
                fontWeight: '500',
                color: '#A5A3AE'
              }}
            >
              {currencyType}
            </span>
          );
        }
      }else{
        return (
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.592 3.83333H11.5833L12 2.5H4.41667L4 3.83333H6.66667C7.69133 3.83333 8.552 4.498 8.866 5.41667H4.41667L4 6.75H8.91733C8.65733 7.75467 7.75267 8.5 6.66667 8.5H4V9.524L8.91667 14.5H10.6667V14.3333L6 9.66667C6.40933 9.66667 6.89533 9.66667 7 9.66667C8.73333 9.66667 10.162 8.404 10.4413 6.75H11.5833L12 5.41667H10.4147C10.2833 4.814 9.99 4.276 9.592 3.83333Z"
              fill="#A5A3AE"
            />
          </svg>
        );
      }
    };

    useEffect(()=>{
      if(currency){
        const selectedCurrency = currencyList.find((item:any)=>item.value === currency)
        const placeholder = selectedCurrency?.value
        setCurrencyType(placeholder)
      }
      },[currency])


  return (
    <Grid
      item
      xs={12}
      id="highlight"
      sx={{
        border: "1px solid #D2D1D6",
        borderRadius: "8px",
        padding: "16px 18px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        margin: "0 16px",
      }}
    >
      <Grid xs={12} sx={{ display: "flex", flexDirection: "column",gap:'6px' }}>
        {jobLocation.length > 0 && (
          <Grid
            xs={12}
            md={12}
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.0013 1.84375C5.43064 1.84375 3.33984 3.93584 3.33984 6.50651C3.33984 9.49518 7.31765 14.35 7.48698 14.5547L8.0013 15.1784L8.51562 14.5547C8.68496 14.3494 12.6628 9.49518 12.6628 6.50651C12.6628 3.93518 10.572 1.84375 8.0013 1.84375ZM8.0013 3.17708C9.83664 3.17708 11.3294 4.67118 11.3294 6.50651C11.3294 8.30984 9.2533 11.4114 8.0013 13.0547C6.7493 11.4127 4.67318 8.31251 4.67318 6.50651C4.67318 4.67118 6.16597 3.17708 8.0013 3.17708ZM8.0013 4.83724C7.08064 4.83724 6.33464 5.58324 6.33464 6.50391C6.33464 7.42457 7.08064 8.17057 8.0013 8.17057C8.92197 8.17057 9.66797 7.42457 9.66797 6.50391C9.66797 5.58324 8.92197 4.83724 8.0013 4.83724Z"
                fill="#A5A3AE"
              />
            </svg>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              {jobLocation && jobLocation.length > 0
                ? jobLocation
                    .map((location: any) => location)
                    .join(", ")
                : ""}
            </Typography>
          </Grid>
        )}
        <Grid xs={12} sx={{ display: "flex" }}>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.9987 2.5V3.16667H2.66536C1.9287 3.16667 1.33203 3.76333 1.33203 4.5V12.5C1.33203 13.2353 1.93003 13.8333 2.66536 13.8333H13.332C14.0674 13.8333 14.6654 13.2353 14.6654 12.5V4.5C14.6654 3.76333 14.0687 3.16667 13.332 3.16667H9.9987V2.5H5.9987ZM2.66536 4.5H13.332V9.16667H11.9987C11.9987 8.98986 11.9285 8.82029 11.8034 8.69526C11.6784 8.57024 11.5088 8.5 11.332 8.5C11.1552 8.5 10.9857 8.57024 10.8606 8.69526C10.7356 8.82029 10.6654 8.98986 10.6654 9.16667H5.33203C5.33203 8.98986 5.26179 8.82029 5.13677 8.69526C5.01174 8.57024 4.84218 8.5 4.66536 8.5C4.48855 8.5 4.31898 8.57024 4.19396 8.69526C4.06894 8.82029 3.9987 8.98986 3.9987 9.16667H2.66536V4.5ZM2.66536 10.5H13.332V12.5H2.66536V10.5Z"
                fill="#A5A3AE"
              />
            </svg>

            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              {`${minExperience} - ${maxExperience} Years`}
            </Typography>
          </Box>
          {/* {!salaryConfidentialToggleChecked && ( */}
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
             

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  whiteSpace: "nowrap",
                  display:'inline-flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'center',
                  marginLeft:'5px'
                }}
              >
              <span style={{color:'#E7E7EA'}}> | </span>
              {renderCurrencyContent()} 
              <span style={{marginLeft:'4px'}}>{`${currency === 'INR' ? (minSalary ? getSalaryWitComma(minSalary):"" ) : (minSalary || "")} - ${currency === 'INR' ? (maxSalary ? getSalaryWitComma(maxSalary) : "" ) : (maxSalary || "")} ${currency}`} </span> 
              </Typography>
            </Box>
          {/* )} */}
        </Grid>
        <Grid xs={12} sx={{ display: "flex",gap:'16px' }}>
          <Grid
            xs={12}
            md={4}
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_18911_233112)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.9987 1.83594C4.59294 1.83594 1.83203 4.59685 1.83203 8.0026C1.83203 11.4084 4.59294 14.1693 7.9987 14.1693C11.4045 14.1693 14.1654 11.4084 14.1654 8.0026C14.1654 4.59685 11.4045 1.83594 7.9987 1.83594ZM0.832031 8.0026C0.832031 4.04456 4.04066 0.835938 7.9987 0.835938C11.9567 0.835938 15.1654 4.04456 15.1654 8.0026C15.1654 11.9606 11.9567 15.1693 7.9987 15.1693C4.04066 15.1693 0.832031 11.9606 0.832031 8.0026ZM7.9987 3.5026C8.27484 3.5026 8.4987 3.72646 8.4987 4.0026V7.69359L10.889 8.88872C11.136 9.01222 11.2361 9.31256 11.1126 9.55954C10.9891 9.80653 10.6887 9.90665 10.4418 9.78315L7.77509 8.44982C7.6057 8.36512 7.4987 8.19199 7.4987 8.0026V4.0026C7.4987 3.72646 7.72256 3.5026 7.9987 3.5026Z"
                  fill="#2B244C"
                />
              </g>
              <defs>
                <clipPath id="clip0_18911_233112">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#A5A3AE",
                whiteSpace: "nowrap",
              }}
            >
              0 hours ago
            </Typography>
          </Grid>
          <Grid
            xs={12}
            md={4}
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.13232 5.36992C3.1098 6.22333 2.39628 7.22393 2.03617 7.79414C1.98699 7.872 1.96585 7.90619 1.95178 7.93327C1.9438 7.94864 1.94167 7.95493 1.93975 7.96291C1.93958 7.96409 1.93924 7.96661 1.93887 7.97053C1.93807 7.97903 1.9375 7.99014 1.9375 8.0026C1.9375 8.01506 1.93807 8.02618 1.93887 8.03468C1.93924 8.0386 1.93958 8.04111 1.93975 8.04229C1.94167 8.05027 1.9438 8.05657 1.95178 8.07194C1.96585 8.09902 1.98699 8.1332 2.03617 8.21107C2.39628 8.78128 3.1098 9.78188 4.13232 10.6353C5.15367 11.4877 6.45319 12.1693 8.00027 12.1693C9.54735 12.1693 10.8469 11.4877 11.8682 10.6353C12.8907 9.78188 13.6043 8.78128 13.9644 8.21107C14.0135 8.1332 14.0347 8.09901 14.0488 8.07194C14.0567 8.05657 14.0589 8.05027 14.0608 8.0423C14.061 8.04112 14.0613 8.0386 14.0617 8.03468C14.0625 8.02618 14.063 8.01506 14.063 8.0026C14.063 7.99014 14.0625 7.97903 14.0617 7.97053C14.0613 7.9666 14.061 7.96409 14.0608 7.96291C14.0589 7.95493 14.0567 7.94864 14.0488 7.93327C14.0347 7.90619 14.0135 7.872 13.9644 7.79414C13.6043 7.22393 12.8907 6.22333 11.8682 5.36992C10.8469 4.51749 9.54735 3.83594 8.00027 3.83594C6.45319 3.83594 5.15367 4.51749 4.13232 5.36992ZM3.49156 4.60218C4.62524 3.656 6.14402 2.83594 8.00027 2.83594C9.85652 2.83594 11.3753 3.656 12.509 4.60218C13.6415 5.54738 14.4197 6.64239 14.8099 7.26016C14.8147 7.26782 14.8196 7.27551 14.8245 7.28326C14.9036 7.40805 14.9912 7.54622 15.0361 7.74195C15.072 7.89875 15.072 8.10646 15.0361 8.26326C14.9912 8.45899 14.9036 8.59716 14.8245 8.72195C14.8196 8.7297 14.8147 8.73739 14.8099 8.74504C14.4197 9.36282 13.6415 10.4578 12.509 11.403C11.3753 12.3492 9.85652 13.1693 8.00027 13.1693C6.14402 13.1693 4.62524 12.3492 3.49156 11.403C2.35906 10.4578 1.58082 9.36282 1.19066 8.74504C1.18583 8.73739 1.18095 8.7297 1.17604 8.72195C1.09692 8.59716 1.00932 8.45899 0.964454 8.26326C0.928515 8.10646 0.928515 7.89875 0.964454 7.74195C1.00932 7.54622 1.09692 7.40805 1.17604 7.28326C1.18095 7.27551 1.18583 7.26782 1.19066 7.26016C1.58082 6.64239 2.35906 5.54738 3.49156 4.60218ZM8.00027 6.5026C7.17184 6.5026 6.50027 7.17418 6.50027 8.0026C6.50027 8.83103 7.17184 9.5026 8.00027 9.5026C8.8287 9.5026 9.50027 8.83103 9.50027 8.0026C9.50027 7.17418 8.8287 6.5026 8.00027 6.5026ZM5.50027 8.0026C5.50027 6.62189 6.61956 5.5026 8.00027 5.5026C9.38098 5.5026 10.5003 6.62189 10.5003 8.0026C10.5003 9.38332 9.38098 10.5026 8.00027 10.5026C6.61956 10.5026 5.50027 9.38332 5.50027 8.0026Z"
                fill="#2B244C"
              />
            </svg>

            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#A5A3AE",
                whiteSpace: "nowrap",
              }}
            >
              0 Viewed
            </Typography>
          </Grid>
          <Grid
            xs={12}
            md={4}
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.3349 3.37324L9.36623 13.5429C9.3553 13.5709 9.34495 13.5974 9.33513 13.6225C9.32533 13.5974 9.31501 13.5709 9.30411 13.5428L7.58524 9.12288L13.3349 3.37324ZM6.87813 8.41577L12.6278 2.66613L2.45813 6.63477C2.43011 6.64571 2.40361 6.65605 2.37853 6.66588C2.40362 6.67567 2.43013 6.68599 2.45816 6.69689L6.87813 8.41577ZM13.8126 1.14282C13.9301 1.10868 14.1327 1.05889 14.3449 1.12978C14.5933 1.21277 14.7882 1.40771 14.8712 1.65613C14.9421 1.86831 14.8923 2.07089 14.8582 2.18844C14.8217 2.31412 14.7623 2.46634 14.6987 2.62904L10.2903 13.9258C10.2194 14.1074 10.1546 14.2735 10.0921 14.3998C10.0364 14.5126 9.92975 14.7118 9.71904 14.8212C9.47789 14.9465 9.19081 14.9463 8.94981 14.8208C8.73922 14.7111 8.63282 14.5118 8.57719 14.3989C8.51491 14.2726 8.45031 14.1064 8.37964 13.9247L6.62004 9.39995L6.61469 9.38632L6.60105 9.38097L2.07633 7.62136C1.89459 7.5507 1.72842 7.48609 1.6021 7.42381C1.48925 7.36818 1.28995 7.26178 1.18023 7.0512C1.05467 6.8102 1.0545 6.52312 1.17978 6.28197C1.28925 6.07126 1.48843 5.96462 1.6012 5.90886C1.72746 5.84643 1.89356 5.78163 2.07522 5.71075L13.372 1.30226C13.5347 1.23875 13.6869 1.17933 13.8126 1.14282Z"
                fill="#2B244C"
              />
            </svg>

            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#A5A3AE",
                whiteSpace: "nowrap",
              }}
            >
              0 Applied
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Highlight;
